import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () =>
        import('@/pages/home/home.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/farm',
      name: 'farm',
      component: () =>
        import('@/pages/page-bak/farm-bak/farm.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/logistics',
      name: 'logistics',
      component: () =>
        import('@/pages/logistics/logistics.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/qrCodeList',
      name: 'qrCodeList',
      component: () =>
        import('@/pages/qrCodeList/qrCodeList.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/newQrCodeList',
      name: 'newQrCodeList',
      component: () =>
        import('@/pages/newStyle/qrCodeList/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/checkReport',
      name: 'checkReport',
      component: () =>
        import('@/pages/checkReport/checkReport.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/sampleVideo',
      name: 'sampleVideo',
      component: () =>
        import('@/pages/sampleVideo/sampleVideo.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/sampleMap',
      name: 'sampleMap',
      component: () =>
        import('@/pages/page-bak/sampleMap-bak/sampleMap.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/share720',
      name: 'share720',
      component: () =>
        import('@/pages/share720/share720.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/wedding',
      name: 'wedding',
      component: () =>
        import('@/pages/wedding/wedding.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/growRecordDetail',
      name: 'growRecordDetail',
      component: () =>
        import('@/pages/home/components/growRecordDetail.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/growCycleDetail',
      name: 'growCycleDetail',
      component: () =>
        import('@/pages/home/components/growCycleDetail/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/newGrowRecordDetail',
      name: 'newGrowRecordDetail',
      component: () =>
        import('@/pages/newStyle/growRecordDetail/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/newGrowCycleDetail',
      name: 'newGrowCycleDetail',
      component: () =>
        import('@/pages/newStyle/growCycleDetail/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/realData',
      name: 'realData',
      component: () =>
        import('@/pages/home/components/realData.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/historyData',
      name: 'historyData',
      component: () =>
        import('@/pages/home/components/historyData.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/prodHistoryData',
      name: 'prodHistoryData',
      component: () =>
        import('@/pages/production/components/historyData.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/deviceShare',
      name: 'deviceShare',
      component: () =>
        import('@/pages/deviceShare/deviceShare.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/deviceShare2',
      name: 'deviceShare2',
      component: () =>
        import('@/pages/deviceShare2/deviceShare2.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/shareHome',
      name: 'shareHome',
      component: () =>
        import('@/pages/deviceShare2//shareHome.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/realDataImg2',
      name: 'realDataImg2',
      component: () =>
        import('@/pages/deviceShare2/components/realDataImg2.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/realDataVideo2',
      name: 'realDataVideo2',
      component: () =>
        import('@/pages/deviceShare2/components/realDataVideo2.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/digitalMap',
      name: 'digitalMap',
      component: () =>
        import('@/pages/deviceShare2/components/digitalMap.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/production',
      name: 'production',
      component: () =>
        import('@/pages/production/production.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/cycleDetail',
      name: 'cycleDetail',
      component: () =>
        import('@/pages/production/components/cycleDetail.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/matterDetail',
      name: 'matterDetail',
      component: () =>
        import('@/pages/production/components/matterDetail.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/blockChain',
      name: 'blockChain',
      component: () =>
        import('@/pages/blockChain/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/newBlockChain',
      name: 'newBlockChain',
      component: () =>
        import('@/pages/newStyle/blockChain/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/newHome',
      name: 'newHome',
      component: () =>
        import('@/pages/newStyle/home/index.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/preSource',
      name: 'preSource',
      component: () =>
        import('@/pages/preBatch/index.vue'),
      meta: {
        keepAlive: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js